/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Orientation } from '@sick-davinci/glow';
import { CrownCapNames } from '../CrownCapNames';
import { CrownImageType } from '../CrownDesc';
import { ImageDataSequentialTilesRenderer } from './renderers/ImageDataSequentialTilesRenderer';
import { Object3D, Vector3 } from 'three';
/**
 * Capability for loading CROWN Images.
 * A new image is put onto a texture of a SOLID rectangle.
 * The rectangle is only added once to every scene.
 * The image-data is pushed as it is into the texture and into the gfx card. Therefore no time is required for preparation.
 */
export class CrownImageCap {
    constructor() {
        this._addedScenes = [];
        const tileSize = this._createTileSize();
        this._renderer = new ImageDataSequentialTilesRenderer(tileSize.width);
        this._object = new Object3D();
    }
    getName() {
        return CrownCapNames.CROWNIMAGE;
    }
    doClassToCapabilityMapping(map) {
        map.set(CrownImageCap.className, CrownCapNames.CROWNIMAGE);
    }
    call(objectIn, sceneIn) {
        const payload = objectIn.payload;
        if (payload.Type === CrownImageCap.className && payload.Iconics.length === 1) { // make sure it is the right object
            const imageData = payload.Iconics[0].data.Data;
            if (this._isImageTypeSupported(imageData.ImageType)) {
                this._renderer.renderToObject3D(this._object, imageData, sceneIn);
                this._scaleObject3D(this._object, imageData);
                this._object.name = objectIn.name;
                if (this._addedScenes.indexOf(sceneIn) === -1) { // only add object to scenes it is not yet added
                    Orientation.set(this._object, objectIn);
                    this._addedScenes.push(sceneIn);
                    sceneIn.addToParent(objectIn.parent || '', this._object);
                    sceneIn.setTag(objectIn.tag, this._object);
                }
                return true;
            }
            else {
                console.error('Image type not supported: ' + imageData.ImageType); // tslint:disable-line:no-console
            }
        }
        return false;
    }
    _isImageTypeSupported(imageType) {
        return CrownImageCap.SUPPORTED_IMAGE_TYPES.indexOf(imageType) >= 0;
    }
    _getMaxTextureSize() {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        return context.getParameter(WebGLRenderingContext.MAX_TEXTURE_SIZE);
    }
    _createTileSize() {
        const maxTextureSize = this._getMaxTextureSize();
        return { width: maxTextureSize, height: maxTextureSize };
    }
    _scaleObject3D(object, imageData) {
        const scaleFactor = new Vector3(1 / imageData.Width, 1 / imageData.Width, 1);
        const flipVec = new Vector3(1, -1, 1); // flip vertically
        const scale = scaleFactor.multiply(flipVec);
        object.scale.set(scale.x, scale.y, scale.z);
    }
}
CrownImageCap.className = 'IMAGE';
CrownImageCap.SUPPORTED_IMAGE_TYPES = [CrownImageType.UINT8, CrownImageType.RGB24];
//# sourceMappingURL=CrownImageCap.js.map